import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en/translation.json";
import cs from "./cs/translation.json";

const resources = {
  en: { translation: en },
  cs: { translation: cs },
};

const SUPPORTED_LANGS = Object.keys(resources);
const FALLBACK_LANG = "en";

async function detectLanguage(): Promise<string> {
  try {
    const saved = localStorage.getItem("lang");
    const forceEnglish = localStorage.getItem("forceEnglish") === "1";
    if (forceEnglish) return FALLBACK_LANG;

    if (saved && SUPPORTED_LANGS.includes(saved)) return saved;

    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();

    const country = data.country_code?.toLowerCase();
    if (country === "cz" || country === "sk") return "cs";

    return FALLBACK_LANG;
  } catch {
    return FALLBACK_LANG;
  }
}

(async () => {
  const lang = await detectLanguage();

  i18n.use(initReactI18next).init({
    resources,
    lng: lang,
    fallbackLng: FALLBACK_LANG,
    interpolation: { escapeValue: false },
  });

  localStorage.setItem("lang", lang);
})();

export default i18n;
